import { createSlice } from '@codeleap/common'

export type SessionState = {
  firebaseUserClaims: {
    [key: string]: any
  },
  registrationWallVariant?:
    | 'unsubscribe'
    | 'contentFirst'
    | 'community-endReached'
    | 'community-search'
    | 'community-filter'
    | 'community-contribute'
    | 'community-lesson'
    | 'community-title'
    | 'community-hurdle'
  onboardingQuestionsWasAppeared: boolean
  abortedAction: 'review' | 'stories'
  hasLoggedOut: boolean
  storyId: number | string
}

const initialState: SessionState = {
  firebaseUserClaims: {},
  registrationWallVariant: null,
  onboardingQuestionsWasAppeared: false,
  abortedAction: null,
  hasLoggedOut: false,
  storyId: null,
}

export const sessionSlice = createSlice({
  name: 'Session',
  initialState,
  reducers: {
    setUserClaims: (state, firebaseUserClaims: SessionState['firebaseUserClaims']) => ({
      ...state,
      firebaseUserClaims,
    }),
    setOnboardingQuestionsWasAppeared: (state, setTo: boolean) => ({
      ...state,
      onboardingQuestionsWasAppeared: setTo,
    }),
    setRegistrationWallVariant: (state, registrationWallVariant: SessionState['registrationWallVariant']) => ({
      ...state,
      registrationWallVariant,
    }),
    setAbortedAction: (state, abortedAction: SessionState['abortedAction']) => ({
      ...state,
      abortedAction,
    }),
    setHasLoggedOut: (state, hasLoggedOut: boolean) => ({
      ...state,
      hasLoggedOut,
    }),
    setStoryId: (state, storyId: number | string) => ({
      ...state,
      storyId,
    }),
  },
  asyncReducers: {},
})
